import type { Components } from "react-markdown";

import { cn } from "@alaffia-technology-solutions/tailwind-utils";

export const Li: Components["li"] = ({ children, className, ...rest }) => (
  <li
    className={cn("af-text-sm [&>p]:af-inline-block [&>p]:af-p-0", className)}
    {...rest}
  >
    {children}
  </li>
);
